/* Olivia-style PDP layout fixer.
 * 1) Relocates the See-it-in-action section into the product-info column.
 * 2) Auto-hides the sticky ATC bar when the footer aside (payment icons) is visible.
 * Re-applies after product-info re-renders (variant changes).
 * NB: no quantity selector on the PDP — the block is removed from the product
 * templates; the stock urgency label (ag-stock-urgency snippet) sits above the ATC. */
(function () {
  'use strict';

  // --- 1) See it in action: move into product-info column ---
  function relocateSeeItInAction() {
    var siia = document.querySelector(
      'section[id*="see_it_in_action"]:not([data-olivia-siia-relocated])'
    );
    if (!siia) return;

    var description = document.querySelector(
      '.product-info__block-list > .product-info__block-item[data-block-type="description"]'
    );
    if (description) {
      description.parentNode.insertBefore(siia, description);
    } else {
      var offers = document.querySelector(
        '.product-info__block-list > .product-info__block-item[data-block-type="offers"]'
      );
      if (!offers) return;
      offers.parentNode.insertBefore(siia, offers.nextSibling);
    }

    siia.classList.add('olivia-siia-relocated');
    siia.setAttribute('data-olivia-siia-relocated', 'true');
  }

  // --- 2) Sticky ATC auto-hide when footer aside (payment icons) is visible ---
  function setupStickyAtcAutoHide() {
    var stickyBar = document.querySelector('product-sticky-bar, .product-sticky-bar');
    if (!stickyBar || typeof IntersectionObserver === 'undefined') return;

    var trigger =
      document.querySelector('.footer .footer__aside') ||
      document.querySelector('.footer .payment-methods') ||
      document.querySelector('footer.shopify-section .footer__aside');

    if (!trigger) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('olivia-sticky-hidden', entry.isIntersecting);
      });
    }, { rootMargin: '0px', threshold: 0 });

    obs.observe(trigger);
  }

  // --- 3) Swatch-slider: geselecteerde swatch in beeld houden ---
  // De CSS maakt van de foto-swatches een horizontale slider. Prestige vervangt
  // het variant-picker-blok bij elke variant-wissel (partial rerender), waardoor
  // de horizontale scrollpositie terugspringt naar 0 en de net-aangetikte swatch
  // uit beeld kan vallen. Na elke wissel (en bij load, bv. ?variant=-deeplinks)
  // de aangevinkte swatch instant centreren. Alleen de container-scrollLeft;
  // nooit de pagina.
  function agCenterSelectedSwatches() {
    try {
      document.querySelectorAll('variant-picker[context="main_product"] .variant-picker__option-values')
        .forEach(function (row) {
          if (row.scrollWidth <= row.clientWidth + 1) return; // geen overflow: niets doen
          var input = row.querySelector('input:checked');
          var label = input && input.id ? row.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
          if (!label) return;
          var left = (label.getBoundingClientRect().left - row.getBoundingClientRect().left) + row.scrollLeft;
          row.scrollLeft = Math.max(0, left - (row.clientWidth - label.offsetWidth) / 2);
        });
    } catch (err) { /* polish-feature mag de PDP nooit breken */ }
  }

  // --- 4) Desktop gallery: variantfoto in de grote hero-tegel, geen page-jump ---
  // Stock Prestige (theme.js onVariantChange_fn) doet op de grid_2x_highlighted
  // desktop-layout een scrollIntoView naar de variant-media => de pagina springt
  // omlaag. In plaats daarvan verplaatsen we die media-cel naar voren (de "eerste
  // zichtbare cel spant 2 kolommen"-CSS in product-gallery.liquid werkt puur op
  // DOM-volgorde), en onderdrukken we de stock-scroll door data-media-id één
  // microtask te detachen (stock doet querySelector('[data-media-id=…]')
  // ?.scrollIntoView => optional-chained, vindt niets, doet niets). Onze
  // capture-listener op document draait gegarandeerd vóór de gallery-listener
  // (die op het form hangt = target-fase). Alles fail-open in try/catch.
  var AG_DESKTOP_MQ = '(min-width: 1000px)';

  function agEsc(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v);
  }

  function agRestoreOrder(carousel) {
    var orig = carousel.__agOriginalOrder;
    if (!orig) return;
    for (var i = 0; i < orig.length; i++) {
      if (orig[i].parentNode === carousel && carousel.children[i] !== orig[i]) {
        carousel.insertBefore(orig[i], carousel.children[i] || null);
      }
    }
  }

  function agOnVariantChangeCapture(event) {
    try {
      var d = event.detail;
      if (!d || !d.variant || !d.variant.featured_media) return;
      if (d.previousVariant && d.previousVariant.featured_media &&
          d.previousVariant.featured_media.id === d.variant.featured_media.id) return;
      if (!window.matchMedia(AG_DESKTOP_MQ).matches) return; // mobiel/tablet: stock gedrag

      var form = event.target;
      var gallery = null;
      if (form && typeof form.id === 'string' && form.id) {
        gallery = document.querySelector('product-gallery[form="' + agEsc(form.id) + '"]');
      }
      if (!gallery && form && form.closest) {
        var sec = form.closest('[id^="shopify-section"]');
        if (sec) gallery = sec.querySelector('product-gallery');
      }
      if (!gallery) return;
      // Producten met Prestige's alt-tag media-groepering overslaan: dan is de
      // index-gebaseerde filtering leidend en zou herordenen die corrumperen.
      var fi = gallery.getAttribute('filtered-indexes');
      if (fi && fi !== '[]') return;
      var carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;
      if (typeof carousel.isScrollable === 'boolean' && carousel.isScrollable) return; // horizontale carousel (mobiel)

      var cell = carousel.querySelector('[data-media-id="' + agEsc(d.variant.featured_media.id) + '"]');
      if (!cell || cell.parentNode !== carousel) return;

      var savedY = window.pageYOffset; // scroll pinnen rond de reorder (zie onder)

      if (!carousel.__agOriginalOrder) {
        carousel.__agOriginalOrder = Array.prototype.slice.call(carousel.children);
      }
      if (carousel.firstElementChild !== cell) {
        agRestoreOrder(carousel);                                // eerst terug naar origineel
        carousel.insertBefore(cell, carousel.firstElementChild); // dan variant-media als hero
      }

      var queue = window.queueMicrotask ? window.queueMicrotask.bind(window)
        : function (fn) { Promise.resolve().then(fn); };

      // Stock smooth page-scroll onderdrukken: data-media-id even weghalen zodat
      // stock's querySelector niets vindt; in een microtask (ná de synchrone
      // event-dispatch, vóór paint) meteen terugzetten.
      if (cell.hasAttribute('data-media-id')) {
        var mid = cell.getAttribute('data-media-id');
        cell.removeAttribute('data-media-id');
        queue(function () { cell.setAttribute('data-media-id', mid); });
      }

      // overflow-anchor:none (CSS) vangt de grote scroll-anchoring-sprong af;
      // dit pint de kleine restdrift (~17px) naar 0 over microtask + 2 frames.
      // De <100px-guard voorkomt dat we ooit een echte gebruikersscroll tegenwerken.
      var pinScroll = function () {
        var dd = window.pageYOffset - savedY;
        if (dd !== 0 && Math.abs(dd) < 100) window.scrollTo(0, savedY);
      };
      queue(pinScroll);
      requestAnimationFrame(function () { pinScroll(); requestAnimationFrame(pinScroll); });
    } catch (err) { /* fail open: stock gedrag */ }
  }

  function agSetupGalleryOrderRestore() {
    // Bij desktop->mobiel de originele volgorde terugzetten zodat de
    // index-gebaseerde mobiele carousel (thumbnails/select-op-positie) klopt.
    try {
      var mq = window.matchMedia(AG_DESKTOP_MQ);
      var handler = function (e) {
        if (e.matches) return;
        document.querySelectorAll('.product-gallery__carousel').forEach(agRestoreOrder);
      };
      if (mq.addEventListener) mq.addEventListener('change', handler);
      else if (mq.addListener) mq.addListener(handler);
    } catch (err) { /* oude browsers: edge-case accepteren */ }
  }

  function init() {
    relocateSeeItInAction();
    setupStickyAtcAutoHide();

    document.addEventListener('variant:change', agOnVariantChangeCapture, true); // capture: vóór stock
    agSetupGalleryOrderRestore();

    document.addEventListener('variant:change', function () { agCenterSelectedSwatches(); }); // bubble: ná rerender
    agCenterSelectedSwatches(); // initiële stand (deep-linked variant)

    var infoRoots = document.querySelectorAll('.product-info, product-rerender');
    if (!infoRoots.length || typeof MutationObserver === 'undefined') return;

    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        relocateSeeItInAction();
      }, 30);
    });
    infoRoots.forEach(function (root) {
      obs.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
